export class StringUtils {
  public static parseBoolean(str: string): boolean {
    if (!str) return false

    switch (str.trim().toLowerCase()) {
      case 'true':
      case '1':
      case 'on':
      case 'yes':
        return true
      default:
        return false
    }
  }

  public static isEmpty(str: string | undefined | null): boolean {
    if (!str) {
      return true
    }
    return str.toString().trim().length === 0
  }

  public static isNotEmpty(str: string | undefined | null): boolean {
    return !this.isEmpty(str)
  }

  static equalsIgnoreCase(a: string | undefined, b: string | undefined): boolean {
    if (!a || StringUtils.isEmpty(a) || !b || StringUtils.isEmpty(b)) {
      return false
    }
    return a.toLowerCase() === b.toLowerCase()
  }
}
